import { render, staticRenderFns } from "./kydt.vue?vue&type=template&id=38992c9c&scoped=true"
import script from "./kydt.vue?vue&type=script&lang=js"
export * from "./kydt.vue?vue&type=script&lang=js"
import style0 from "./kydt.vue?vue&type=style&index=0&id=38992c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38992c9c",
  null
  
)

export default component.exports